import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const HeroSection = () => {
  return (
    <section className="relative min-h-[600px] md:min-h-[700px] flex items-center">
      {/* Background Video */}
      <div className="absolute inset-0 z-0 overflow-hidden">
        <video
          poster="/Assets/videos/hero-poster.jpg"
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover"
          data-testid="hero-video"
        >
          <source src="/Assets/videos/hero-video-web.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-black/30" />
      </div>

      {/* Content - Centered */}
      <div className="container-portico relative z-10 py-20 flex flex-col items-center text-center">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-primary-foreground mb-10 leading-tight"
        >
          High Performance Flooring
        </motion.h1>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="flex flex-wrap justify-center gap-4"
        >
          <Link to="/contact">
            <Button size="lg" variant="secondary" className="font-semibold group">
              Request a Consultation
              <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Button>
          </Link>
          <Link to="/products">
            <Button 
              size="lg" 
              variant="outline" 
              className="font-semibold border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary"
            >
              Explore Products
            </Button>
          </Link>
        </motion.div>
      </div>

      {/* Scroll indicator - Text with arrow */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.5 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center"
      >
        <span className="text-primary-foreground/80 text-sm font-medium mb-2">
          Scroll to View More
        </span>
        <motion.div
          animate={{ y: [0, 6, 0] }}
          transition={{ duration: 1.5, repeat: Infinity }}
        >
          <ChevronDown className="w-6 h-6 text-primary-foreground/80" />
        </motion.div>
      </motion.div>
    </section>
  );
};

export default HeroSection;
